var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "app-container bj-label-colon label-width-6 bj-el-input-disabled",
    },
    [
      _c(
        "BjDivider",
        { staticStyle: { "margin-bottom": "0" }, attrs: { "right-fixed": "" } },
        [
          _vm._v(
            _vm._s(_vm.$t("DetailsOfThirdPartySalesOrder.information")) + " "
          ),
          _c(
            "template",
            { slot: "button" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    placement: "top",
                    content: _vm.$t("InternalOrder.No"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { "margin-left": "20px" },
                      attrs: {
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        placeholder: _vm.$t("InternalOrder.No"),
                        "remote-method": _vm.remoteMethod,
                        loading: _vm.loading,
                      },
                      on: { change: _vm.getOrderInfo },
                      model: {
                        value: _vm.outerOrderNo,
                        callback: function ($$v) {
                          _vm.outerOrderNo = $$v
                        },
                        expression: "outerOrderNo",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "bj-row",
          staticStyle: { border: "none", "border-bottom": "1px solid #d7d7d7" },
        },
        [
          _c("div", { staticClass: "bj-col bj-col-6" }, [
            _c("div", { staticClass: "bj-form-title" }, [
              _vm._v(
                _vm._s(_vm.$t("ExternalOrders.newAdd.receivingInformation"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryName"))),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.info.receiverInfoVO.receiverName)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryPhone"))),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.info.receiverInfoVO.phone))]),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("ExternalOrders.newAdd.DestinationCountry")) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.info.receiverInfoVO.country))]),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryState")) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.info.receiverInfoVO.province))]),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.DeliverySuburb"))),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.info.receiverInfoVO.district))]),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(
                  _vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryPostcode"))
                ),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.info.receiverInfoVO.zipCode))]),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(
                  _vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryAddress1"))
                ),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.info.receiverInfoVO.deliveryAddress1)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(
                  _vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryAddress2"))
                ),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.info.receiverInfoVO.deliveryAddress2)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.emailAddress"))),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.info.receiverInfoVO.deliveryEmailAddress)),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "bj-col bj-col-18" },
            [
              _c("div", { staticClass: "bj-form-title" }, [
                _vm._v(_vm._s(_vm.$t("AddInternalRefundOnlyDoc.Product"))),
              ]),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.thirdItemVO,
                    stripe: "",
                    border: "",
                    "max-height": "251px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "innerSkuName",
                      label: _vm.$t("ExternalOrders.newAdd.ProductName"),
                      "show-overflow-tooltip": "",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "standardSkuCode",
                      label: _vm.$t("ExternalOrders.newAdd.ProductSKU"),
                      "show-overflow-tooltip": "",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "spuCode",
                      label: _vm.$t("BusinessPurchaseOrder3.Batch"),
                      "show-overflow-tooltip": "",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: _vm.$t("goodsSku.detail.qty"),
                      "show-overflow-tooltip": "",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "size",
                      label: _vm.$t("goodsSku.detail.Size"),
                      "show-overflow-tooltip": "",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "weight",
                      label: _vm.$t("goodsSku.detail.Weight"),
                      "show-overflow-tooltip": "",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "BjDivider",
        { staticClass: "mt20", staticStyle: { "margin-bottom": "0" } },
        [
          _vm._v(_vm._s(_vm.$t("SalesOrderEntry.SearchpriceInfo")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    placement: "top",
                    content: "Carton / Pallet",
                  },
                },
                [
                  _c("BjSelectLov", {
                    staticClass: "mr20",
                    attrs: {
                      placeholder: "Carton / Pallet",
                      "option-list": [
                        { label: "Carton", value: "carton" },
                        { label: "Pallet", value: "pallet" },
                      ],
                      clearable: "",
                    },
                    on: { change: _vm.CartonPalletTypeChange },
                    model: {
                      value: _vm.CartonPalletType,
                      callback: function ($$v) {
                        _vm.CartonPalletType = $$v
                      },
                      expression: "CartonPalletType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    placement: "top",
                    content: "Auto / Manual",
                  },
                },
                [
                  _c("BjSelectLov", {
                    staticClass: "mr20",
                    attrs: {
                      placeholder: "Auto / Manual",
                      "option-list": [
                        { label: "Auto", value: "auto" },
                        { label: "Manual", value: "manual" },
                      ],
                      clearable: false,
                    },
                    on: { change: _vm.logiTypeChange },
                    model: {
                      value: _vm.logiType,
                      callback: function ($$v) {
                        _vm.logiType = $$v
                      },
                      expression: "logiType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    placement: "top",
                    content: _vm.$t("LogisticsRulesTable.header.Logistics"),
                  },
                },
                [
                  _c("BjSelectLov", {
                    staticClass: "mr20",
                    attrs: {
                      "option-list": _vm.LogisticsList,
                      placeholder: _vm.$t(
                        "LogisticsRulesTable.header.Logistics"
                      ),
                      multiple: "",
                      clearable: _vm.isClear,
                    },
                    model: {
                      value: _vm.logisticsName,
                      callback: function ($$v) {
                        _vm.logisticsName = $$v
                      },
                      expression: "logisticsName",
                    },
                  }),
                ],
                1
              ),
              _vm.logiType == "auto" && _vm.palletHShow == true
                ? _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        placement: "top",
                        content: _vm.$t("billingPage.palletHeight"),
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        staticClass: "mr20",
                        attrs: {
                          placeholder: _vm.$t("billingPage.palletHeight"),
                          clearable: true,
                        },
                        model: {
                          value: _vm.palletHeight,
                          callback: function ($$v) {
                            _vm.palletHeight = $$v
                          },
                          expression: "palletHeight",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "0", "margin-right": "16px" },
                  attrs: { disabled: _vm.cantDoAnything, type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSearch()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("SalesOrderEntry.Searchprice")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.logiType == "auto"
        ? _c(
            "div",
            {
              staticClass: "bj-row",
              staticStyle: {
                border: "none",
                "border-bottom": "1px solid #d7d7d7",
              },
            },
            [
              _c(
                "div",
                { staticClass: "bj-col-24" },
                [
                  _c("div", { staticClass: "bj-form-title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("OrdinaryOrderMix.LogisticsTable.Details"))
                    ),
                  ]),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.autoPriceList,
                        border: "",
                        "max-height": "251px",
                        "row-style": _vm.tableRowStyle,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "provider",
                          label: _vm.$t("LogisticsRulesTable.header.Logistics"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "totalPrice",
                          label: _vm.$t("OrderPostage.total"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(_vm.formatTotalPrice(scope.row))
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1246340126
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "ratePrice",
                          label: _vm.$t("billingPage.ratePrice"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "responseCode",
                          label: this.$t(
                            "InternalSalesOrderDetailsSearchTable.responseCode"
                          ),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        trigger: "hover",
                                        placement: "top",
                                        content: scope.row.responseMsg,
                                        disabled: !scope.row.responseMsg,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "name-wrapper",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.responseCode) +
                                              " "
                                          ),
                                          scope.row.responseCode == "FAILED"
                                            ? _c("i", {
                                                staticClass: "el-icon-warning",
                                                staticStyle: { color: "red" },
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1372880895
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "logisticsType",
                          label: _vm.$t("BjDialogListConfig.Types"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "packageList.length",
                          label: _vm.$t("WarehouseManagement.form.if"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "rgb(39, 55, 204)",
                                        cursor: "pointer",
                                      },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onView(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.packageList.length) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("span", [
                                    _vm._v(" " + _vm._s(scope.row.packageType)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3118549185
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "rateDate",
                          label: _vm.$t("dateText"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("timeFilters")(
                                            scope.row.rateDate,
                                            scope.row.rateDate
                                          )
                                        )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          488413950
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("BusinessThirdOrderAdd.form.Operation"),
                          align: "center",
                          fixed: "right",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        disabled:
                                          (scope.row.responseCode == "FAILED" &&
                                            ![
                                              "LossOrder",
                                              "Shipping service has been disabled by the customer.",
                                            ].includes(
                                              scope.row.responseMsg
                                            )) ||
                                          _vm.cantDoAnything,
                                        type: "text",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onSelect(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("selectText")))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3084073503
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.logiType == "manual"
        ? _c(
            "div",
            {
              staticClass: "bj-row",
              staticStyle: {
                border: "none",
                "border-bottom": "1px solid #d7d7d7",
              },
            },
            [
              _c(
                "div",
                { staticClass: "bj-col-24 mb20" },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "bj-form-title",
                        staticStyle: {
                          float: "left",
                          "line-height": "2",
                          "margin-right": "30px",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("OrdinaryOrderMix.LogisticsTable.Details")
                          )
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          float: "right",
                          "margin-bottom": "10px",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: _vm.cantDoAnything,
                            },
                            on: { click: _vm.onAddOne },
                          },
                          [_vm._v(_vm._s(_vm.$t("addText")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "packageListForm",
                      attrs: { model: _vm.packageListForm, rules: _vm.rules },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.packageListForm.packageList,
                            stripe: "",
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: _vm.$t(
                                "DetailsOfThirdPartySalesOrder.Serial"
                              ),
                              align: "center",
                              width: "60",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "red" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "DetailsOfThirdPartySalesOrder.Quantity"
                                            )
                                          )
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    var $index = ref.$index
                                    return [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            "margin-top": "10px !important",
                                          },
                                          attrs: {
                                            prop:
                                              "packageList." +
                                              $index +
                                              ".quantity",
                                            rules: _vm.rules.quantity,
                                          },
                                        },
                                        [
                                          _c("BjInputNumber", {
                                            staticClass: "full-width",
                                            attrs: {
                                              clearable: "",
                                              controls: false,
                                            },
                                            model: {
                                              value: row.quantity,
                                              callback: function ($$v) {
                                                _vm.$set(row, "quantity", $$v)
                                              },
                                              expression: "row.quantity",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3189731332
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "red" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "WarehouseManagement.form.Length"
                                            )
                                          )
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    var $index = ref.$index
                                    return [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            "margin-top": "10px !important",
                                          },
                                          attrs: {
                                            prop:
                                              "packageList." +
                                              $index +
                                              ".packageLength",
                                            rules: _vm.rules.packageLength,
                                          },
                                        },
                                        [
                                          _c(
                                            "BjInputNumber",
                                            {
                                              staticClass: "full-width",
                                              attrs: {
                                                clearable: "",
                                                controls: false,
                                              },
                                              model: {
                                                value: row.packageLength,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "packageLength",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.packageLength",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("cm")]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1271835199
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "red" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "WarehouseManagement.form.Width"
                                            )
                                          )
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    var $index = ref.$index
                                    return [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            "margin-top": "10px !important",
                                          },
                                          attrs: {
                                            prop:
                                              "packageList." +
                                              $index +
                                              ".packageWidth",
                                            rules: _vm.rules.packageWidth,
                                          },
                                        },
                                        [
                                          _c(
                                            "BjInputNumber",
                                            {
                                              staticClass: "full-width",
                                              attrs: {
                                                clearable: "",
                                                controls: false,
                                              },
                                              model: {
                                                value: row.packageWidth,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "packageWidth",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.packageWidth",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("cm")]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2606043807
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "red" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "WarehouseManagement.form.Height"
                                            )
                                          )
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    var $index = ref.$index
                                    return [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            "margin-top": "10px !important",
                                          },
                                          attrs: {
                                            prop:
                                              "packageList." +
                                              $index +
                                              ".packageHeight",
                                            rules: _vm.rules.packageHeight,
                                          },
                                        },
                                        [
                                          _c(
                                            "BjInputNumber",
                                            {
                                              staticClass: "full-width",
                                              attrs: {
                                                clearable: "",
                                                controls: false,
                                              },
                                              model: {
                                                value: row.packageHeight,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "packageHeight",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.packageHeight",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("cm")]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1323801055
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "red" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "WarehouseManagement.form.Weight"
                                            )
                                          )
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    var $index = ref.$index
                                    return [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            "margin-top": "10px !important",
                                          },
                                          attrs: {
                                            prop:
                                              "packageList." +
                                              $index +
                                              ".packageWeight",
                                            rules: _vm.rules.packageWeight,
                                          },
                                        },
                                        [
                                          _c(
                                            "BjInputMoney",
                                            {
                                              staticClass: "full-width",
                                              attrs: {
                                                clearable: "",
                                                controls: false,
                                              },
                                              model: {
                                                value: row.packageWeight,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "packageWeight",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.packageWeight",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("kg")]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2093840590
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessThirdOrderAdd.form.Operation"
                              ),
                              align: "center",
                              fixed: "right",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled: _vm.cantDoAnything,
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDelete(scope.$index)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("delText")))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3911090954
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.listShow
                ? _c(
                    "div",
                    { staticClass: "bj-col-24 mb20" },
                    [
                      _c("div", { staticClass: "bj-form-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SalesOrderEntry.PriceSearchResults"))
                        ),
                      ]),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.manualPriceList,
                            border: "",
                            "max-height": "251px",
                            "row-style": _vm.tableRowStyle,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "provider",
                              label: _vm.$t(
                                "LogisticsRulesTable.header.Logistics"
                              ),
                              "show-overflow-tooltip": "",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "totalPrice",
                              label: _vm.$t("OrderPostage.total"),
                              "show-overflow-tooltip": "",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        _vm._s(_vm.formatTotalPrice(scope.row))
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1246340126
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "ratePrice",
                              label: _vm.$t("billingPage.ratePrice"),
                              "show-overflow-tooltip": "",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "responseCode",
                              label: this.$t(
                                "InternalSalesOrderDetailsSearchTable.responseCode"
                              ),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            trigger: "hover",
                                            placement: "top",
                                            content: scope.row.responseMsg,
                                            disabled: !scope.row.responseMsg,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "name-wrapper",
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.responseCode
                                                  ) +
                                                  " "
                                              ),
                                              scope.row.responseCode == "FAILED"
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-warning",
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1372880895
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "logisticsType",
                              label: _vm.$t("BjDialogListConfig.Types"),
                              "show-overflow-tooltip": "",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "rateDate",
                              label: _vm.$t("dateText"),
                              "show-overflow-tooltip": "",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row.rateDate,
                                                scope.row.rateDate
                                              )
                                            )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              488413950
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessThirdOrderAdd.form.Operation"
                              ),
                              align: "center",
                              fixed: "right",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled:
                                              (scope.row.responseCode ==
                                                "FAILED" &&
                                                ![
                                                  "LossOrder",
                                                  "Shipping service has been disabled by the customer.",
                                                ].includes(
                                                  scope.row.responseMsg
                                                )) ||
                                              _vm.cantDoAnything,
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSelect(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("selectText")))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3084073503
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "bj-row mt20", staticStyle: { border: "none" } },
        [
          _c("div", { staticClass: "bj-col-4" }, [
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(_vm._s(_vm.$t("LogisticsRulesTable.header.Logistics"))),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "large",
                    },
                  },
                  [_vm._v(_vm._s(_vm.manualRatingVO.provider))]
                ),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("InternalSalesOrderDetails.PaymentTableSubTotalGST")
                  )
                ),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _vm.manualRatingVO.totalPrice
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "large",
                        },
                      },
                      [_vm._v("$" + _vm._s(_vm.manualRatingVO.totalPrice))]
                    )
                  : _c("span"),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "bj-col-10" }, [
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(_vm._s(_vm.$t("billingPage.instruction"))),
              ]),
              _c(
                "div",
                { staticClass: "bj-form-item-value" },
                [
                  _c("BjInput", {
                    staticStyle: { width: "90%" },
                    attrs: {
                      disabled: _vm.cantDoAnything,
                      placeholder: _vm.$t("billingPage.instruction"),
                      type: "textarea",
                      "show-word-limit": "",
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                    },
                    model: {
                      value: _vm.instructions,
                      callback: function ($$v) {
                        _vm.instructions = $$v
                      },
                      expression: "instructions",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "bj-col-10" }, [
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-formItemLabel" }, [
                _vm._v(_vm._s(_vm.$t("billingPage.Comments"))),
              ]),
              _c(
                "div",
                { staticClass: "bj-form-item-value" },
                [
                  _c("BjInput", {
                    staticStyle: { width: "90%" },
                    attrs: {
                      disabled: _vm.cantDoAnything,
                      placeholder: _vm.$t("billingPage.Comments"),
                      type: "textarea",
                      "show-word-limit": "",
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                    },
                    model: {
                      value: _vm.logisticsComment,
                      callback: function ($$v) {
                        _vm.logisticsComment = $$v
                      },
                      expression: "logisticsComment",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "bj-row mt20",
          staticStyle: {
            border: "none",
            display: "flex",
            "justify-content": "center",
          },
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission:BusinessLogisticButton",
                  arg: "BusinessLogisticButton",
                },
              ],
              staticStyle: { width: "200px" },
              attrs: {
                disabled: _vm.canClick,
                type: "primary",
                size: "medium",
              },
              on: {
                click: function ($event) {
                  return _vm.onManualOrder()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("billingPage.PlaceOrder")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission:BusinessLogisticButton",
                  arg: "BusinessLogisticButton",
                },
              ],
              staticStyle: { width: "200px" },
              attrs: {
                disabled: _vm.canPrint,
                type: "primary",
                size: "medium",
              },
              on: {
                click: function ($event) {
                  return _vm.onPrint()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("billingPage.printLabel")))]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, width: "500px" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.dialogList,
                border: "",
                script: "",
                "max-height": "600px",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: _vm.$t("billingPage.index"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "length",
                  label: _vm.$t("goodsSku.detail.Size"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { attrs: { type: "text" } }, [
                          _vm._v(
                            _vm._s(scope.row.length) +
                              "*" +
                              _vm._s(scope.row.width) +
                              "*" +
                              _vm._s(scope.row.height)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }